export function isCssColor(color?: string | false): boolean {
  return !!color && !!color.match(/^(#|var\(--|(rgb|hsl)a?\()/);
}
export function getColorByName(color?: string) {
  // @ts-ignore
  if (color && color.startsWith('#') || color && color.startsWith('rgb')) {
    return color;
  }
  switch (color) {
    case "_color_azure_dark" : return "#279DF2";
    case "_color_azure_light" : return "#6FB7EB";
    case "_color_sea_dark" : return "#0047FF";
    case "_color_sea_light" : return "#5E89FA";
    case "_color_violet_dark" : return "#621FF0";
    case "_color_violet_light" : return "#9063F0";
    case "_color_sun_dark" : return "#F7C209";
    case "_color_sun_light" : return "#F1CD4C";
    case "_color_flame_dark" : return "#FF7A00";
    case "_color_flame_light" : return "#FBA24F";
    case "_color_beauty_dark" : return "#F01F51";
    case "_color_beauty_light" : return "#F86286";
    case "_color_tenderness_dark" : return "#EF5DA8";
    case "_color_tenderness_light" : return "#F58DC3";
    case "_color_spring_dark" : return "#54CB6E";
    case "_color_spring_light" : return "#79E090";
    case "_color_mint_dark" : return "#57B9A7";
    case "_color_mint_light" : return "#6FE9D3";
    case "_color_snow_dark" : return "#F4F4F4";
    case "_color_snow_light" : return "#FFFFFF";
    case "_color_neutral_dark" : return "#939393";
    case "_color_neutral_light" : return "#B6B6B6";
    case "_color_night_dark" : return "#3F414D";
    case "_color_night_light" : return "#626573";
    default: return "#279DF2";
  }
}


// WEBPACK FOOTER //
// ./src/uikit/utils/colorUtils.ts